import { render } from "./TheCartOrderReceivingAddress.vue?vue&type=template&id=20ddd464"
import script from "./TheCartOrderReceivingAddress.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceivingAddress.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__